/* eslint-disable jsx-a11y/no-onchange */
import { instanceOf, func, shape } from "prop-types"
import moment from "moment-timezone"

const DayPickerMonthYearSelect = ({ date, fromMonth, localeUtils, onChange, toMonth }) => {
  const months = localeUtils.getMonths()

  const years = []
  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i)
  }

  const handleChange = event => {
    const { year, month } = event.target.form
    onChange(new Date(year.value, month.value))
  }

  return (
    <form className="DayPicker-Caption">
      <div className="d-f px-2">
        <select
          name="month"
          className="select"
          css={{
            borderRadius: 0,
            fontSize: 14,
            height: "1.5rem"
          }}
          onChange={handleChange}
          value={moment(date).month()}
        >
          {months.map((month, i) => (
            <option key={month} value={i}>
              {moment()
                .month(i)
                .format("MMM")}
            </option>
          ))}
        </select>
        <select
          name="year"
          className="select"
          css={{
            borderLeft: 0,
            borderRadius: 0,
            fontSize: 14,
            height: "1.5rem"
          }}
          onChange={handleChange}
          value={date.getFullYear()}
        >
          {years.map(year => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
    </form>
  )
}

DayPickerMonthYearSelect.propTypes = {
  date: instanceOf(Date),
  fromMonth: instanceOf(Date),
  localeUtils: shape({
    getMonths: func
  }),
  onChange: func,
  toMonth: instanceOf(Date)
}

export default DayPickerMonthYearSelect
